import React from 'react';
import { Link } from 'react-router-dom';

import bgImg from '../../assets/img/footer/bg-1-1.jpg';
import Logo from '../../assets/img/logo/logo.png';
import footerImg1 from '../../assets/img/footer/lamp1.png';
import footerImg2 from '../../assets/img/footer/lamp2.png';
import footerImg3 from '../../assets/img/footer/lamp3.png';
import footerImg4 from '../../assets/img/footer/lamp7.png';
import footerImg5 from '../../assets/img/footer/woman1.png';
import footerImg6 from '../../assets/img/footer/woman2.png';

const Footer = (props) => {
  const { footerClass, footerLogo, copyrightTextClass } = props;

  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : 'it-footer-area it-footer-bg black-bg pt-120 pb-70'
        }
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-footer-widget footer-col-1">
                <div className="it-footer-logo pb-25">
                  <Link to="/">
                    <img src={footerLogo ? footerLogo : Logo} alt="" />
                  </Link>
                </div>
                <div className="it-footer-text pb-5">
                  <p>
                  The B.Sc. Nursing at Servite College empowers women with quality education, preparing them for roles as
                  skilled nurses, educators, and healthcare leaders.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="it-footer-widget footer-col-2">
                <h4 className="it-footer-title">our services:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li>
                      <Link to="/admission">
                        <i className="fa-regular fa-angle-right"></i>Admission
                      </Link>
                    </li>
                    <li>
                      <Link to="/teacher">
                        <i className="fa-regular fa-angle-right"></i>Faculties
                      </Link>
                    </li>
                    <li>
                      <Link to="/gallery">
                        <i className="fa-regular fa-angle-right"></i>Gallery
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xl-2 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-footer-widget footer-col-3">
                <h4 className="it-footer-title">quick links:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li>
                      <Link to="/">
                        <i className="fa-regular fa-angle-right"></i>Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about-us">
                        <i className="fa-regular fa-angle-right"></i>About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        <i className="fa-regular fa-angle-right"></i>Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".9s"
            >
              <div className="it-footer-widget footer-col-4">
                <h4 className="it-footer-title">Gallery</h4>
                <div className="it-footer-gallery-box">
                  <div className="row gx-10">
                    <div className="col-md-4 col-4">
                      <div className="it-footer-thumb mb-10">
                        <Link to="/gallery">
                          <img src={footerImg1} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4 col-4">
                      <div className="it-footer-thumb mb-10">
                        <Link to="/gallery">
                          <img src={footerImg2} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4 col-4 mb-10">
                      <div className="it-footer-thumb">
                        <Link to="/gallery">
                          <img src={footerImg3} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4 col-4">
                      <div className="it-footer-thumb">
                        <Link to="/gallery">
                          <img src={footerImg4} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4 col-4">
                      <div className="it-footer-thumb">
                        <Link to="/gallery">
                          <img src={footerImg5} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4 col-4">
                      <div className="it-footer-thumb">
                        <Link to="/gallery">
                          <img src={footerImg6} alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height">
        <div className="container">
          <div className="row">
            <div
              className="col-12 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div
                className={
                  copyrightTextClass
                    ? copyrightTextClass
                    : 'it-copyright-text text-center'
                }
              >
                <p>
                  Copyright &copy; 2024 <Link to="/">Servite Nursing College</Link> || All Rights
                  Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
